export class MembersMessagingConstants {

    public static MEMBERS_ADD_TO_PROPERTY_CONFIRMATION = (): string => 
        "Are you sure you want to add {firstName} {lastName} to this Property?";
 
    public static MEMBERS_DETACH_FROM_PROPERTY_CONFIRMATION = (): string => 
        "Are you sure you want to detach {firstName} {lastName} from this Property?";
 
    public static MEMBERS_UPDATE_STATUS_CONFIRMATION = (): string => 
        "Are you sure you want to {actionText} {firstName} {lastName}'s Member account?";
 
    public static MEMBERS_DELETE_CONFIRMATION = (): string => 
        "Are you sure you want to delete {firstName} {lastName}'s Member account?";
 
    public static MEMBERS_BULK_ACTION_CONFIRMATION = (): string => 
        "Are you sure you want to {actionText} {selectedCount} Member account(s)?";

    public static MEMBERS_BULK_DELETE_TYPE_TO_CONFIRM = (): string =>
        "DELETE MEMBERS";

    public static MEMBERS_BULK_ACTION_STATUS_UPDATE_SUCCESS = (): string =>
        "You have {actionText} {totalAffected} Member account(s). {totalSkipped} account(s) skipped.";

    public static MEMBERS_BULK_SELF_EXCLUDED_NOTE = (): string =>
        "Your own account will not be {actionText}.";

    public static MEMBERS_SEND_INVITATION_CONFIRMATION = (): string => 
        "Are you sure you want to send an invitation to {firstName} {lastName}? Invites are valid for {expirationDays} days.";
 
    public static MEMBERS_SEND_INVITATION_SUCCESS = (): string => 
        "The invitation email message was sent successfully to {firstName} {lastName}.";
 
    public static MEMBERS_SEND_INVITATION_FAILURE = (): string =>
        "Failed to send invitation email message.";
 
    public static MEMBERS_UNINVITE_CONFIRMATION = (): string =>
        "Are you sure you want to cancel the invitation for {firstName} {lastName}?";
 
    public static MEMBERS_UNINVITE_SUCCESS = (): string =>
        "Invitation canceled successfully.";

    public static MEMBERS_BULK_INVITE_CONFIRMATION = (): string =>
        "Invites will only send to Members with the status of Created and Expired.";

    public static MEMBERS_BULK_UNINVITE_CONFIRMATION = (): string =>
        "Only Members with the status of Invited will be uninvited.";

    public static MEMBERS_BULK_INVITE_SUCCESS = (): string =>
        "Invitations sent to {totalAffected} of {totalEvaluated} Member(s). {totalSkipped} skipped.";

    public static MEMBERS_BULK_UNINVITE_SUCCESS = (): string =>
        "Uninvited {totalAffected} of {totalEvaluated} Member(s). {totalSkipped} skipped.";

    public static MEMBERS_CREATE_SUCCESS = (): string =>
        "Member has been created successfully.";

    public static MEMBERS_EDIT_CONFIRMATION = (): string =>
        "Are you sure you want to save changes to {firstName} {lastName}'s Member account?";

    public static MEMBERS_EDIT_SUCCESS = (): string =>
        "Member has been updated successfully.";

    public static MEMBERS_EDIT_ERROR = (): string =>
        "Failed to update the Member.";

    public static MEMBERS_ERROR_EMAIL_IN_USE = (): string =>
        "This email address already is in use.";

    public static MEMBERS_UPDATE_MEMBER_STATUS_SUCCESS = (): string => 
        "You have {actionText} {firstName} {lastName}'s Member account.";

    public static MEMBERS_DELETE_MEMBER_SUCCESS = (): string => 
        "You have deleted {firstName} {lastName}'s Member account.";

    public static MEMBERS_BULK_DELETE_SUCCESS = (): string => 
        "You have deleted {totalAffected} Member account(s). {totalSkipped} account(s) skipped.";

    public static MEMBERS_TRANSFER_ORG_OWNERSHIP = (): string =>
        "Organization Ownership has been transferred successfully.";

    public static MEMBERS_ADD_ROLE_SUCCESS = (): string =>
        "Role has been added successfully.";

    public static MEMBERS_ROLE_REMOVAL_SUCCESS = (): string =>
        "Role has been removed successfully.";

    public static MEMBERS_DIRECTORY_VISIBILITY_SAVE_SUCCESS = (): string =>
        "Your member directory visibility has been updated.";

    public static MEMBERS_DIRECTORY_VISIBILITY_SAVE_FAILURE = (): string =>
        "Failed to update your member directory visibility.";

    public static MEMBERS_DIRECTORY_LOAD_FAILURE = (): string =>
        "Failed to load the member directory.";

    public static MEMBERS_DIRECTORY_VISIBILITY_LABEL = (): string =>
        "Include me in the member directory";

    public static MEMBERS_DIRECTORY_VISIBILITY_HELP = (): string =>
        "When this is on, other members of this organization can see your name, email address and phone number in the directory. Turn it off to hide yourself. You can turn it back on at any time.";

    public static MEMBERS_DIRECTORY_VISIBILITY_HIDDEN_WARNING = (): string =>
        "You will not appear in the member directory, so other members cannot find your contact details there.";
}
 
export class OrganizationsMessagingConstants {

    public static MANAGE_ADMINS_ELEVATED_PRIVILEGES_WARNING = (): string =>
        "Organization Admins have elevated privileges to manage organization settings, members, and properties. Only grant admin access to trusted members.";

    // Stable identifier for the DismissibleNotesService — persisted in localStorage, so renaming
    // this value abandons every existing dismissal. Change only if the note itself materially changes.
    public static MANAGE_ADMINS_ELEVATED_PRIVILEGES_WARNING_DISMISS_KEY = (): string =>
        'manage-admins-elevated-privileges-warning';

    public static ORGANIZATIONS_ADMIN_NOT_FOUND = (): string =>
        "Organization Administrator role not found.";
 
    public static ORGANIZATIONS_ERROR_LOADING_ROLES = (): string =>
        "An unexpected error occurred while loading roles.";
 
    public static ORGANIZATIONS_ADMIN_ROLEID_NOT_FOUND = (): string =>
        "Administrator role ID not available.";
 
    public static ORGANIZATIONS_ERROR_LOADING_ADMINS = (): string =>
        "Failed to load Organization Administrator(s).";
 
    public static ORGANIZATIONS_GRANT_ADMIN_PERMISSION = (): string =>
        "Are you sure you want to assign Administrator privileges to {firstName} {lastName}?";
 
    public static ORGANIZATIONS_ERROR_GRANTING_ADMIN_PERMISSION = (): string =>
        "An unexpected error occurred while assigning Administrator privileges.";
 
    public static ORGANIZATIONS_REMOVE_ADMIN_ROLE = (): string =>
        "Are you sure you want to remove Administrator privileges from {firstName} {lastName}?";
 
    public static ORGANIZATIONS_ERROR_REMOVING_ADMIN_ROLE = (): string =>
        "An unexpected error occurred while removing Administrator privileges.";
 
    public static ORGANIZATIONS_DEACTIVATE_CONFIRMATION = (): string =>
        "Are you sure you want to deactivate {organizationName}?</br></br>This will deactivate all Member accounts, expire all pending invitations, deactivate all invoice schedules, and stop emails sent from the organization. Stripe will remain connected.";

    public static ORGANIZATIONS_REACTIVATE_CONFIRMATION = (): string =>
        "Are you sure you want to reactivate {organizationName}?</br></br>Members and invoice schedules will remain deactivated and must be reactivated individually. All other organization functions will be restored.";

    public static ORGANIZATIONS_DEACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "DEACTIVATE ORGANIZATION";

    public static ORGANIZATIONS_REACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "REACTIVATE ORGANIZATION";

    public static ORGANIZATIONS_DEACTIVATE_ACTION_LABEL = (): string =>
        "Deactivate";

    public static ORGANIZATIONS_REACTIVATE_ACTION_LABEL = (): string =>
        "Reactivate";

    public static ORGANIZATIONS_OWNER_ROLE_NOT_FOUND = (): string =>
        "Organization Owner role not found.";
 
    public static ORGANIZATIONS_OWNER_NOT_FOUND = (): string =>
        "Failed to load Organization Owner.";
 
    public static ORGANIZATIONS_TRANSFER_OWNERSHIP_CONFIRMATION = (): string => 
        "Are you sure you want to remove your Organization Owner credentials and add them to {firstName} {lastName} instead?";
 
    public static ORGANIZATIONS_ERROR_TRANSFERING_OWNERSHIP = (): string =>
        "An unexpected error occurred while transferring Organization Ownership.";

    public static ORGANIZATIONS_ASSIGN_OWNER_CONFIRMATION = (): string =>
        "Are you sure you want to assign {firstName} {lastName} as the Organization Owner?";

    public static ORGANIZATIONS_ASSIGN_OWNER_SUCCESS = (): string =>
        "Organization Owner has been assigned successfully.";

    public static ORGANIZATIONS_ERROR_ASSIGNING_OWNER = (): string =>
        "An unexpected error occurred while assigning the Organization Owner.";
 
    public static ORGANIZATIONS_ERROR_LOADING_ORGANIZATION_PROFILE = (): string => 
        "Error loading Organization Profile.";

    public static ORGANIZATIONS_ADD_ORGANIZATION_SUCCESS = (): string => 
        "Organization has been created successfully.";

    public static ORGANIZATIONS_ERROR_SLUG_IN_USE = (): string => 
        "Requested slug already is in use.";

    public static ORGANIZATIONS_UPDATE_STATUS_SUCCESS = (): string =>
        "{organizationName} has been {actionText} successfully."

    public static ORGANIZATIONS_UPLOAD_AVATAR_SUCCESS = (): string =>
        "{organizationName}'s Avatar has been updated successfully.";

    public static ORGANIZATIONS_DELETE_AVATAR = (): string =>
        "Are you sure you want to delete this Organization's avatar?</br>You cannot undo this change.";

    public static ORGANIZATIONS_DELETE_AVATAR_SUCCESS = (): string =>
        "Avatar deleted successfully.";

    public static ORGANIZATIONS_ERROR_DELETE_AVATAR = (): string =>
        "Failed to remove avatar. Please try again.";

    public static ORGANIZATIONS_REMOVE_CONTACT_CONFIRMATION = (): string =>
        "Are you sure you want to remove {contactName}?";

    public static ORGANIZATIONS_CONTACT_SAVE_CONFIRMATION = (): string =>
        "Are you sure you want to save changes to the {contactType} contact?";

    public static ORGANIZATIONS_CONTACT_SAVE_SUCCESS = (): string =>
        "Contact saved successfully.";

    public static ORGANIZATIONS_CONTACT_REMOVE_SUCCESS = (): string =>
        "Contact removed successfully.";

    public static ORGANIZATIONS_CONTACT_SAVE_FAILURE = (): string =>
        "Failed to save contact. Please try again.";

    public static ORGANIZATIONS_CONTACT_REMOVE_FAILURE = (): string =>
        "Failed to remove contact. Please try again.";

    public static ORGANIZATIONS_NO_CONTACTS_TITLE = (): string =>
        "No contacts on file.";

    public static ORGANIZATIONS_NO_CONTACTS_HELP = (): string =>
        "Click \"Add / Edit\" to get started.";

    public static ORGANIZATIONS_REMOVE_ADDRESS_CONFIRMATION = (): string =>
        "Are you sure you want to remove the {addressType} address?";

    public static ORGANIZATIONS_ADDRESS_SAVE_CONFIRMATION = (): string =>
        "Are you sure you want to save changes to the {addressType} address?";

    public static ORGANIZATIONS_ADDRESS_SAVE_SUCCESS = (): string =>
        "Address saved successfully.";

    public static ORGANIZATIONS_ADDRESS_REMOVE_SUCCESS = (): string =>
        "Address removed successfully.";

    public static ORGANIZATIONS_ADDRESS_SAVE_FAILURE = (): string =>
        "Failed to save address. Please try again.";

    public static ORGANIZATIONS_ADDRESS_REMOVE_FAILURE = (): string =>
        "Failed to remove address. Please try again.";

    public static ORGANIZATIONS_NO_ADDRESSES_TITLE = (): string =>
        "No addresses on file.";

    public static ORGANIZATIONS_NO_ADDRESSES_HELP = (): string =>
        "Click \"Add / Edit\" to get started.";

    public static ORGANIZATIONS_DIRECTORY_DEFAULT_LABEL = (): string =>
        "List new members in the member directory by default";

    public static ORGANIZATIONS_DIRECTORY_DEFAULT_HELP = (): string =>
        "Applies only to members who join after you change this. Existing members keep their current setting, and every member can change their own visibility at any time.";
}
 
export class PropertiesMessagingConstants {

    public static PROPERTIES_ADD_MEMBERS_TO_PROPERTY_CONFIRMATION = (): string => 
        "Are you sure you want to add the selected Member(s) to this Property?";
 
    public static PROPERTIES_ERROR_NO_MEMBER_SELECTED = (): string => 
        "Please select at least one Member to add.";
 
    public static PROPERTIES_ERROR_LOADING_PROPERTY_PROFILE = (): string =>
        "Error loading Property Profile.";

    public static PROPERTIES_ADD_PROPERTY_SUCCESS = (): string =>
        "Property added successfully.";

    public static PROPERTIES_ADD_MEMBER_TO_PROPERTY_SUCCESS = (): string =>
        "Member added to Property successfully.";

    public static PROPERTIES_ADD_MEMBERS_TO_PROPERTY_SUCCESS = (): string =>
        "Member(s) added to Property successfully.";

    public static PROPERTIES_REMOVE_MEMBER_FROM_PROPERTY_SUCCESS = (): string =>
        "Removed Member from Property.";

    public static PROPERTIES_REMOVE_MEMBERS_FROM_PROPERTY_SUCCESS = (): string =>
        "Removed Member(s) from Property.";

    public static PROPERTIES_EDIT_PROPERTY_CONFIRMATION = (): string =>
        "Are you sure you want to save your edits to the Property {propertyLabel}?";

    public static PROPERTIES_EDIT_PROPERTY_SUCCESS = (): string =>
        "Property updated successfully.";

    public static PROPERTIES_EDIT_PROPERTY_ERROR = (): string =>
        "An unexpected error occurred while editing one or more Properties.";

    public static PROPERTIES_DELETE_CONFIRMATION = (): string =>
        "Are you sure you want to delete the Property {propertyLabel}? Deletion of this Property will void all unpaid invoices associated with it.";

    public static PROPERTIES_DELETE_SUCCESS = (): string =>
        "Property has been deleted successfully.";

    public static PROPERTIES_DELETE_ERROR = (): string =>
        "An unexpected error occurred while deleting one or more Properties.";

    public static PROPERTIES_BULK_DELETE_CONFIRMATION = (): string =>
        "Are you sure you want to delete {selectedCount} Properties? Deletion of these Properties will void all unpaid invoices associated with them.";

    public static PROPERTIES_BULK_DELETE_SUCCESS = (): string =>
        "You have deleted {totalAffected} Properties.";

    public static PROPERTIES_UPDATE_STATUS_CONFIRMATION = (): string =>
        "Are you sure you want to {actionText} the Property {propertyLabel}?";

    public static PROPERTIES_UPDATE_STATUS_SUCCESS = (): string =>
        "Property has been {actionText} successfully.";

    public static PROPERTIES_BULK_STATUS_CONFIRMATION = (): string =>
        "Are you sure you want to {actionText} {selectedCount} Properties?";

    public static PROPERTIES_BULK_STATUS_SUCCESS = (): string =>
        "You have {actionText} {totalAffected} Properties.";

    public static PROPERTIES_BULK_DEACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "DEACTIVATE PROPERTIES";

    public static PROPERTIES_BULK_REACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "REACTIVATE PROPERTIES";

    public static PROPERTIES_DEFAULT_COUNTRY_HINT = (): string =>
        "The default country is determined by the Physical address entered in Organization Settings";
}
 
export class StripeMessagingConstants {

    public static STRIPE_ORGANIZATION_DISCONNECTED = (): string =>
        "Your Organization has disconnected from Stripe.";

    public static STRIPE_ERROR_ORGANIZATION_DISCONNECTED = (): string =>
        "Failed to disconnect Organization from Stripe.";

    public static STRIPE_ERROR_FAILED_TO_GET_ACCOUNT_SESSION = (): string =>
        "Failed to get Stripe account session.";

    public static STRIPE_PAYMENT_METHOD_ADDED = (): string =>
        "Payment method added successfully.";

    public static STRIPE_PAYMENT_METHOD_DELETED = (): string =>
        "Payment method has been removed.";

    public static STRIPE_PAYMENT_METHOD_DELETE_CONFIRMATION = (): string =>
        "Are you sure you want to remove this payment method?";

    public static STRIPE_ERROR_LOADING_PAYMENT_METHODS = (): string =>
        "Failed to load payment methods.";

    public static STRIPE_ERROR_ADDING_PAYMENT_METHOD = (): string =>
        "Failed to add payment method. Please try again.";

    public static STRIPE_ERROR_DELETING_PAYMENT_METHOD = (): string =>
        "Failed to remove payment method. Please try again.";

    public static STRIPE_ERROR_CREATING_SETUP_INTENT = (): string =>
        "Failed to initialize payment form. Please try again.";

    public static STRIPE_BANK_ACCOUNT_ADDED = (): string =>
        "Bank account added successfully.";

    public static STRIPE_ERROR_ADDING_BANK_ACCOUNT = (): string =>
        "Failed to add bank account. Please try again.";

    public static STRIPE_ONBOARDING_OWNER_ONLY = (): string =>
        "Only the Organization Owner can connect your organization to Stripe.";

    public static STRIPE_DISCONNECT_OWNER_ONLY = (): string =>
        "Only the Organization Owner can disconnect your organization from Stripe.";

    public static STRIPE_BANK_ACCOUNT_MICRODEPOSIT_WARNING = (): string =>
        "Stripe makes microdeposits into your bank account to begin verifying it as an ACH payment source. This process can take 1-2 business days to complete. Stripe will e-mail you instructions to complete verification. Your bank account will not appear on your list of payment methods until you complete the verification process.";
}
 
export class UsersMessagingConstants {

    public static USERS_ADD_SUCCESS = (): string =>
        "User has been created successfully.";
 
    public static USERS_UPDATE_ACTIVATION_STATUS_CONFIRMATION = (): string =>
        "Are you sure you want to {actionText} {firstName} {lastName}'s User account?";
 
    public static USERS_DELETE_USER_CONFIRMATION = (): string =>
        "Are you sure you want to delete {firstName} {lastName}'s User account?";
 
    public static USERS_BULK_ACTION_CONFIRMATION = (): string =>
        "Are you sure you want to {bulkAction} {selectedCount} User account(s)?";

    public static USERS_BULK_SELF_EXCLUDED_NOTE = (): string =>
        "Your own account will not be deactivated.";

    public static USERS_BULK_ACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "ACTIVATE USERS";

    public static USERS_BULK_DEACTIVATE_TYPE_TO_CONFIRM = (): string =>
        "DEACTIVATE USERS";
 
    public static USERS_DELETE_AVATAR = (): string =>
        "Are you sure you want to delete your avatar?</br>You cannot undo this change.";
 
    public static USERS_DELETE_AVATAR_SUCCESS = (): string =>
        "Avatar deleted successfully.";
 
    public static USERS_ERROR_DELETE_AVATAR = (): string =>
        "Failed to remove avatar. Please try again.";
 
    public static USERS_TOGGLE_ACTIVATION_CONFIRMATION = (): string =>
        "Are you sure you want to {actionText} {firstName} {lastName}?";
 
    public static USERS_RESET_OWN_PASSWORD_CONFIRMATION = (): string =>
        "Are you sure you want to reset your password?";
 
    public static USERS_RESET_OTHERS_PASSWORD_CONFIRMATION = (): string =>
        "Are you sure you want to send a password reset to {firstName} {lastName}?";

    public static USERS_ERROR_NO_ACTIVE_USER = (): string =>
        "Your request could not be processed. No active User.";
 
    public static USERS_PASSWORD_RESET_SUCCESSFUL = (): string =>
        "The password reset message was sent successfully to {firstName} {lastName}.";
 
    public static USERS_ERROR_EMAIL_IN_USE = (): string =>
        "This email address already is in use.";
 
    public static USERS_ERROR_UPDATING_USER = (): string =>
        "Something went wrong while updating the User. Please try again.";

    public static USERS_EDIT_CONFIRMATION = (): string =>
        "Are you sure you want to save changes to {firstName} {lastName}'s User account?";

    public static USERS_PROFILE_UPDATE_SUCCESS = (): string =>
        "Profile updated successfully.";

    public static USERS_ERROR_UPDATING_PROFILE = (): string =>
        "Failed to update User Profile.";

    public static USERS_BULK_ACTIVATION_CONFIRMATION = ():string => 
        "You have {bulkAction} {totalAffected} User account(s). {totalSkipped} account(s) skipped.";

    public static USERS_UPDATE_STATUS = ():string => 
        "You have {actionText} {firstName} {lastName}'s User account.";

    public static USERS_UPLOAD_USER_AVATAR_SUCCESS = ():string => 
        "{firstName} {lastName}'s Avatar has been updated successfully.";

    public static USERS_USER_DELETE_SUCCESS = ():string => 
        "You have deleted {firstName} {lastName}'s User account.";

    public static USERS_ERROR_PASSWORD_RESET = ():string => 
        "Failed to send password reset.";
}
 
export class SystemMessagesMessagingConstants {

    public static SYSTEM_MESSAGES_PAGE_NOT_FOUND_HEADING = (): string =>
        "This page seems to have moved out";

    public static SYSTEM_MESSAGES_PAGE_NOT_FOUND_DESCRIPTION = (): string =>
        "We couldn't find the page you were looking for — it may have been moved or no longer exists. Let's get you back home.";

    public static SYSTEM_MESSAGES_FORBIDDEN_HEADING = (): string =>
        "This area is off-limits";

    public static SYSTEM_MESSAGES_FORBIDDEN_DESCRIPTION = (): string =>
        "Your account doesn't have permission to view this page. If you think this is a mistake, reach out to your administrator.";

    public static SYSTEM_MESSAGES_SERVER_ERROR_HEADING = (): string =>
        "Something went wrong on our end";

    public static SYSTEM_MESSAGES_SERVER_ERROR_DESCRIPTION = (): string =>
        "We hit an unexpected snag while loading this page. Please try again in a few moments.";

    public static SYSTEM_MESSAGES_UNAUTHORIZED_HEADING = (): string =>
        "You're not authorized to view this";

    public static SYSTEM_MESSAGES_UNAUTHORIZED_DESCRIPTION = (): string =>
        "It looks like your account doesn't have access to that resource. Head back home, or contact your administrator if you need access.";

    public static SYSTEM_MESSAGES_INVITATION_ERROR_HEADING = (): string =>
        "We couldn't process that invitation";

    public static SYSTEM_MESSAGES_INVITATION_ERROR_DESCRIPTION = (): string =>
        "This invitation link may have expired or already been used. Please request a new invitation to continue.";

    public static SYSTEM_MESSAGES_AUTH_ERROR_HEADING = (): string =>
        "Unable to load your account";

    public static SYSTEM_MESSAGES_AUTH_ERROR_DESCRIPTION = (): string =>
        "We signed you in, but couldn't load your account information. Please try again or contact support if this continues.";

    public static SYSTEM_MESSAGES_ACCOUNT_DEACTIVATED_HEADING = (): string =>
        "Your account has been deactivated";

    public static SYSTEM_MESSAGES_ACCOUNT_DEACTIVATED_DESCRIPTION = (): string =>
        "You can no longer sign in with this account. If you think this is a mistake, contact your administrator to have it reactivated.";

    public static SYSTEM_MESSAGES_MAINTENANCE_HEADING = (): string =>
        "We'll be back shortly";

    public static SYSTEM_MESSAGES_MAINTENANCE_DESCRIPTION = (): string =>
        "Membershine is undergoing scheduled maintenance. This page will return you to the app automatically once we're done.";

    public static SYSTEM_MESSAGES_GENERIC_HEADING = (): string =>
        "Something went wrong";

    public static SYSTEM_MESSAGES_GENERIC_DESCRIPTION = (): string =>
        "We couldn't load the page you were looking for. Let's get you back home.";
}
 
export class GenericMessagingConstants {

    public static GENERIC_ABORT_CONFIRMATION = (): string => 
        "Are you sure you want to leave? Your changes will be lost.";

    public static GENERIC_ERROR_OCCURRED = (): string => 
        "Your request could not be processed.";
} 

export class PaymentMessagingConstants {

    public static PAYMENT_LOADING_SUMMARY = (): string =>
        "Loading payment summary...";

    public static PAYMENT_PROCESSING = (): string =>
        "Processing your payment...";

    public static PAYMENT_SUCCESS_CARD = (): string =>
        "Your payment of {amount} has been processed successfully.";

    public static PAYMENT_SUCCESS_ACH = (): string =>
        "Your payment of {amount} has been submitted. ACH payments typically take 3-5 business days to complete.";

    public static PAYMENT_ERROR = (): string =>
        "We were unable to process your payment. Please try again or use a different payment method.";

    public static PAYMENT_ERROR_LOADING_PREVIEW = (): string =>
        "Failed to load payment preview. Please try again.";

    public static PAYMENT_ERROR_CREATING_INTENT = (): string =>
        "Failed to initiate payment. Please try again.";

    public static PAYMENT_ERROR_CONFIRMING = (): string =>
        "Payment confirmation failed. Please try again or use a different payment method.";

    public static PAYMENT_ONE_TIME_CARD_LABEL = (): string =>
        "Credit or Debit Card";

    public static PAYMENT_ONE_TIME_ACH_LABEL = (): string =>
        "Bank Account (ACH)";

    public static PAYMENT_LOADING_FORM = (): string =>
        "Loading payment form...";

    public static PAYMENT_ACH_VERIFICATION_REQUIRED = (): string =>
        "Your payment of {amount} has been submitted. Stripe will send microdeposits to your bank account to verify it. This process typically takes 1-2 business days. You will receive an email from Stripe with instructions to complete verification. Your payment will be processed once verification is complete.";

    public static PAYMENT_ONLINE_PAYMENTS_DISABLED_TOOLTIP = (): string =>
        "Online payments are not enabled. Please contact your Organization Administrator if you have questions.";
}

export class BalancesMessagingConstants {

    public static PAYMENT_NO_ROW_ACTIONS_TOOLTIP = (): string =>
        "No actions are available for this payment.";

    public static PROPERTY_CHARGE_SCHEDULE_DOWNLOAD_TOOLTIP = (): string =>
        "Please select one or more invoice schedules before attempting to download data.";

    public static PROPERTY_CHARGE_SCHEDULE_STRIPE_WARNING = (): string =>
        "You will be unable to accept online payments unless and until you set up an active Stripe account. Please {stripeSetupLink} to set up Stripe.";

    public static PROPERTY_CHARGE_SCHEDULE_STRIPE_WARNING_LINK_TEXT = (): string =>
        "click here";

    public static PROPERTY_CHARGE_SCHEDULE_FORM_TIMEZONE_WARNING = (): string =>
        "Issuance and due dates are based on your organization's timezone setting. Currently, your organization's timezone is set to {timezone}.";

    // Stable identifier for the DismissibleNotesService — persisted in localStorage, so renaming
    // this value abandons every existing dismissal. Change only if the note itself materially changes.
    public static PROPERTY_CHARGE_SCHEDULE_FORM_TIMEZONE_WARNING_DISMISS_KEY = (): string =>
        'property-charge-schedule-form-timezone-warning';

    public static PROPERTY_CHARGE_SCHEDULE_SAVE_CONFIRMATION = (): string =>
        "Are you sure you want to save changes to this invoice schedule?";

    public static PROPERTY_CHARGE_SCHEDULE_EDIT_PROPERTIES_CONFIRMATION = (): string =>
        "Editing the attached properties will clear the current selection. You will need to reselect all properties that this invoice schedule should apply to. Continue?";

    public static PROPERTY_CHARGE_SCHEDULE_REACTIVATION_PAST_DATES = (): string =>
        "This invoice schedule uses one or more past dates. You will not be able to activate this invoice schedule unless you edit the dates.";

    public static PROPERTY_CHARGE_SCHEDULE_RETROACTIVE_FEE_WARNING = (): string =>
        "Changing this will update {count} existing open invoice(s) generated by this schedule. Paid and voided invoices will not be affected.";

    public static PROPERTY_CHARGE_SCHEDULE_CREATE_SUCCESS = (): string =>
        "Invoice schedule created successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_CREATE_FAILURE = (): string =>
        "Failed to create invoice schedule.";

    public static PROPERTY_CHARGE_SCHEDULE_UPDATE_SUCCESS = (): string =>
        "Invoice schedule updated successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_UPDATE_FAILURE = (): string =>
        "Failed to update invoice schedule.";

    public static PROPERTY_CHARGE_SCHEDULE_DELETE_CONFIRMATION = (): string =>
        "Deleting this Invoice Schedule stops future invoices from being generated. "
        + "Invoices that have been created by this Invoice Schedule will remain on the Invoice Dashboard. <br /><br />"
        + "Are you sure you want to delete this Invoice Schedule?";

    public static PROPERTY_CHARGE_SCHEDULE_DELETE_VOID_INVOICES_LABEL = (): string =>
        "Void <strong>Open</strong> and <strong>Late</strong> invoices that have been created by this Invoice Schedule";

    public static PROPERTY_CHARGE_SCHEDULE_DELETE_SEND_NOTIFICATIONS_LABEL = (): string =>
        "Send email notifications";

    public static PROPERTY_CHARGE_SCHEDULE_DELETE_SUCCESS = (): string =>
        "Invoice schedule deleted successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_DELETE_FAILURE = (): string =>
        "Failed to delete invoice schedule. Please try again.";

    public static PROPERTY_CHARGE_SCHEDULE_DEACTIVATE_ACTION_LABEL = (): string =>
        "Deactivate";

    public static PROPERTY_CHARGE_SCHEDULE_REACTIVATE_ACTION_LABEL = (): string =>
        "Reactivate";

    public static PROPERTY_CHARGE_SCHEDULE_DEACTIVATE_CONFIRMATION = (): string =>
        "Are you sure? Deactivated Invoice Schedules will not generate invoices. "
        + "Invoices already generated by the Invoice Schedule remain payable by Members. "
        + "Late Fees will continue to be applied to invoices already generated.";

    public static PROPERTY_CHARGE_SCHEDULE_DEACTIVATE_SUCCESS = (): string =>
        "Invoice schedule deactivated successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_DEACTIVATE_FAILURE = (): string =>
        "Failed to deactivate invoice schedule. Please try again.";

    public static PROPERTY_CHARGE_SCHEDULE_REACTIVATE_SUCCESS = (): string =>
        "Invoice schedule reactivated successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_REACTIVATE_FAILURE = (): string =>
        "Failed to reactivate invoice schedule. Please try again.";

    public static PROPERTY_CHARGE_SCHEDULE_LATE_FEES_LOCKED = (): string =>
        "This schedule has already issued one or more invoices, so its late fee configuration can no longer be modified.";

    public static PROPERTY_CHARGE_SCHEDULE_LATE_FEES_NONE_CONFIGURED = (): string =>
        "No late fees were configured for this schedule, and they cannot be added because invoices have already been issued.";

    public static PROPERTY_CHARGE_SCHEDULE_LATE_FEES_UPDATE_SUCCESS = (): string =>
        "Late fee configuration updated successfully.";

    public static PROPERTY_CHARGE_SCHEDULE_LATE_FEES_UPDATE_FAILURE = (): string =>
        "The invoice schedule was saved, but the late fee configuration failed to update. Please try again.";

    public static EXPENSE_CREATE_SUCCESS = (): string =>
        "Payment entry has been created successfully.";

    public static EXPENSE_CREATE_FAILURE = (): string =>
        "Failed to create payment entry.";

    public static EXPENSE_UPDATE_CONFIRMATION = (): string =>
        "Are you sure you want to edit this expense?";

    public static EXPENSE_UPDATE_SUCCESS = (): string =>
        "Expense has been updated successfully.";

    public static EXPENSE_UPDATE_FAILURE = (): string =>
        "Failed to update the expense.";

    public static EXPENSE_VOID_CONFIRMATION = (): string =>
        "Are you sure you want to void this expense?";

    public static EXPENSE_VOID_SUCCESS = (): string =>
        "Expense has been voided successfully.";

    public static EXPENSE_VOID_FAILURE = (): string =>
        "Failed to void the expense.";

    public static EXPENSE_VOID_BLOCKED_RECONCILED = (): string =>
        "This expense has been reconciled against a bank transaction. Undo the match in Bank Reconciliation before voiding it.";

    public static EXPENSE_VOID_BLOCKED_RECONCILED_NO_BANK_REC = (): string =>
        "This expense has been reconciled against a bank transaction and cannot be voided.";

    public static MARK_INVOICE_PAID_CONFIRMATION = (): string =>
        "Are you sure you want to mark Invoice #{invoiceId} as <strong>Paid</strong>?";

    public static MARK_INVOICE_VOID_CONFIRMATION = (): string =>
        "Are you sure you want to mark Invoice #{invoiceId} as <strong>Void</strong>?";

    public static MARK_INVOICE_PAID_SUCCESS = (): string =>
        "Invoice #{invoiceId} has been marked as Paid.";

    public static MARK_INVOICE_VOID_SUCCESS = (): string =>
        "Invoice #{invoiceId} has been marked as Void.";

    public static MARK_INVOICE_FAILURE = (): string =>
        "Failed to update invoice. Please try again.";

    public static MARK_INVOICE_VOID_BLOCKED_REFUND = (): string =>
        "This invoice must be refunded before it can be voided. Invoices can be refunded on the Payment Dashboard.";

    public static MARK_INVOICE_VOID_BLOCKED_UNMARK = (): string =>
        "This invoice must be unmarked as paid before it can be voided. Invoices can be unmarked as paid on the Payment Dashboard.";

    public static MARK_INVOICE_VOID_BLOCKED_UNKNOWN = (): string =>
        "This invoice has been paid. It must be refunded or unmarked as paid on the Payment Dashboard before it can be voided.";

    public static MARK_INVOICE_VOID_BLOCKED_REFUND_NO_ACCESS = (): string =>
        "This invoice was paid electronically and must be refunded before it can be voided.";

    public static MARK_INVOICE_VOID_BLOCKED_UNMARK_NO_ACCESS = (): string =>
        "This invoice was marked as paid and must be unmarked before it can be voided.";

    public static MARK_INVOICE_VOID_BLOCKED_UNKNOWN_NO_ACCESS = (): string =>
        "This invoice has been paid and must be refunded or unmarked as paid before it can be voided.";

    public static UNMARK_PAYMENT_CONFIRMATION = (): string =>
        "Are you sure you want to unmark the manual payment for Invoice #{invoiceId}? This will void the manual payment record.";

    public static UNMARK_PAYMENT_SUCCESS = (): string =>
        "The manual payment for Invoice #{invoiceId} has been unmarked.";

    public static UNMARK_PAYMENT_FAILURE = (): string =>
        "Failed to unmark this payment. Please try again.";

    public static WAIVE_LATE_FEES_INDIVIDUAL_CONFIRMATION = (): string =>
        "Are you sure you want to <strong>waive all applied late fees</strong> on Invoice #{invoiceId}? This reverses the applied fees but does not stop future scheduled fees from applying.";

    public static WAIVE_LATE_FEES_BULK_CONFIRMATION = (): string =>
        "Are you sure you want to <strong>waive late fees</strong> on {selectedCount} selected invoice(s)? Paid invoices in the selection will be skipped.";

    public static WAIVE_LATE_FEES_SUCCESS = (): string =>
        "Late fees on Invoice #{invoiceId} have been waived.";

    public static WAIVE_LATE_FEES_BULK_SUCCESS = (): string =>
        "Late fees waived on {totalAffected} of {totalEvaluated} invoice(s). {totalSkipped} skipped.";

    public static WAIVE_LATE_FEES_FAILURE = (): string =>
        "Failed to waive late fees. Please try again.";

    public static BULK_RESEND_INVOICES_CONFIRMATION = (): string =>
        "Are you sure you want to <strong>resend {selectedCount} selected invoice(s)</strong>? Voided invoices in the selection will be skipped.";

    public static BULK_RESEND_INVOICES_SUCCESS = (): string =>
        "Invoices resent to {totalAffected} of {totalEvaluated} recipient(s). {totalSkipped} skipped.";

    public static BULK_RESEND_INVOICES_FAILURE = (): string =>
        "Failed to resend invoices. Please try again.";

    public static BULK_RESEND_RECEIPTS_CONFIRMATION = (): string =>
        "Are you sure you want to <strong>resend {selectedCount} selected receipt(s)</strong>? Payments without receipts will be skipped.";

    public static BULK_RESEND_RECEIPTS_SUCCESS = (): string =>
        "Receipts resent to {totalAffected} of {totalEvaluated} recipient(s). {totalSkipped} skipped.";

    public static BULK_RESEND_RECEIPTS_FAILURE = (): string =>
        "Failed to resend receipts. Please try again.";

    public static REFUND_PAYMENT_CONFIRMATION = (): string =>
        "Are you sure you want to refund this payment?";

    public static REFUND_PAYMENT_SUCCESS = (): string =>
        "Refund initiated successfully. The status will update once Stripe confirms the refund.";

    public static REFUND_PAYMENT_FAILURE = (): string =>
        "Failed to refund this payment. Please try again.";

    public static REFUND_PAYMENT_INSUFFICIENT_FUNDS = (): string =>
        "Your Organization's Stripe account doesn't have enough available balance to cover this refund. Add funds or wait for pending payments to settle, then try again.";

    public static CANCEL_REFUND_CONFIRMATION = (): string =>
        "Are you sure you want to cancel this refund?";

    public static CANCEL_REFUND_SUCCESS = (): string =>
        "Refund canceled successfully.";

    public static CANCEL_REFUND_FAILURE = (): string =>
        "Failed to cancel this refund. Please try again.";

    public static CANCEL_PAYMENT_CONFIRMATION = (): string =>
        "Are you sure you want to cancel this payment?<br />"
        + "The invoice(s) will go back to Open, or to Late if it's past its due date.";

    public static CANCEL_PAYMENT_SUCCESS = (): string =>
        "Payment cancelation was requested successfully. The payment will show as Canceled once the cancelation is confirmed.";

    public static CANCEL_PAYMENT_FAILURE = (): string =>
        "Failed to cancel this payment. Please try again.";

    public static RESEND_RECEIPT_SUCCESS = (): string =>
        "Receipt resent successfully.";

    public static RESEND_RECEIPT_FAILURE = (): string =>
        "Failed to resend the receipt. Please try again.";

    public static RESEND_INVOICE_SUCCESS = (): string =>
        "Invoice resent successfully.";

    public static RESEND_INVOICE_FAILURE = (): string =>
        "Failed to resend the invoice. Please try again.";

    public static RESEND_REFUND_STATEMENT_SUCCESS = (): string =>
        "Refund statement resent successfully.";

    public static RESEND_REFUND_STATEMENT_FAILURE = (): string =>
        "Failed to resend the refund statement. Please try again.";
}

export class ManualGLEntryMessagingConstants {

    public static MANUAL_GL_ENTRY_CREATE_SUCCESS = (): string =>
        "Manual ledger entries have been created successfully.";

    public static MANUAL_GL_ENTRY_CREATE_FAILURE = (): string =>
        "Failed to create manual ledger entries.";
}

export class BudgetMessagingConstants {

    public static BUDGET_CREATE_SUCCESS = (): string =>
        "Budget was created successfully.";

    public static BUDGET_CREATE_FAILURE = (): string =>
        "Budget was not created. Please try again.";

    public static BUDGET_UPDATE_SUCCESS = (): string =>
        "Budget was updated successfully.";

    public static BUDGET_UPDATE_FAILURE = (): string =>
        "Budget was not updated. Please try again.";

    public static BUDGET_LOAD_FAILURE = (): string =>
        "We couldn't load this budget. Please try again.";

    public static BUDGET_ALREADY_EXISTS_FOR_YEAR = (): string =>
        "A budget already exists for this year.";

    public static BUDGET_LIST_EMPTY = (): string =>
        "No budgets available to select.";

    public static BUDGET_LIST_LOAD_FAILURE = (): string =>
        "Failed to load budgets. Please try again.";

    public static BUDGET_DELETE_CONFIRMATION = (): string =>
        "Are you sure you want to delete the {name} Budget?";

    public static BUDGET_DELETE_SUCCESS = (): string =>
        "You have deleted the {name} Budget.";

    public static BUDGET_SUMMARY_LOAD_FAILURE = (): string =>
        "We couldn't load this budget. Please try again.";

    public static BUDGET_NOT_FOUND = (): string =>
        "Budget not found.";
}

export class DocumentsMessagingConstants {

    public static DOCUMENTS_UPLOAD_SUCCESS = (): string =>
        "\"{name}\" uploaded.";

    public static DOCUMENTS_UPLOAD_RENAMED = (): string =>
        "A file with that name already existed — uploaded as \"{name}\".";

    // Summary shown once a multi-file batch finishes, in place of a per-file message.
    public static DOCUMENTS_UPLOAD_BATCH_SUCCESS = (): string =>
        "{count} files uploaded.";

    public static DOCUMENTS_UPLOAD_BATCH_SUCCESS_RENAMED = (): string =>
        "{count} files uploaded — {renamed} renamed to avoid duplicate names.";

    public static DOCUMENTS_UPLOAD_TOO_LARGE = (): string =>
        "This file exceeds the {limit} limit.";

    public static DOCUMENTS_UPLOAD_MAX_SIZE_HINT = (): string =>
        "Max {limit} per file.";

    public static DOCUMENTS_UPLOAD_EMPTY_FILE = (): string =>
        "This file is empty (0 bytes) and can't be uploaded.";

    public static DOCUMENTS_UPLOAD_FAILED = (): string =>
        "Upload failed. {reason}";

    public static DOCUMENTS_UPLOAD_SAS_EXPIRED = (): string =>
        "The upload timed out. Please try again.";

    public static DOCUMENTS_UPLOAD_LEAVE_CONFIRM = (): string =>
        "An upload is still in progress and will be cancelled if you leave. Leave anyway?";

    // Folder drag-drop is not supported in v1 (nested-structure preservation is a future capability).
    // Shown as the reason on a failed row in the upload dock — the same place real upload failures
    // appear — so a folder drop never needs a one-off modal/banner that could trap the user behind the
    // OS file-explorer window they dragged from.
    public static DOCUMENTS_UPLOAD_FOLDER_NOT_SUPPORTED = (): string =>
        "Folder upload is not currently supported — please select individual files.";

    // Heading on the full-page drop overlay; phrased for multi-file drops.
    public static DOCUMENTS_UPLOAD_MULTI_HINT = (): string =>
        "Drop files to upload them here";

    // The bulk prepare is all-or-nothing: exceeding the storage limit rejects the batch before any upload starts.
    public static DOCUMENTS_UPLOAD_BATCH_LIMIT_EXCEEDED = (): string =>
        "This batch would exceed the organization's remaining storage limit, so no files were uploaded. Remove some files and try again.";

    // Generic all-or-nothing rejection when the bulk prepare fails without a specific reason.
    public static DOCUMENTS_UPLOAD_BATCH_REJECTED = (): string =>
        "The upload could not be started, so no files were uploaded. Please try again.";

    // Total declared size of the files queued for upload, shown in the progress dock header.
    public static DOCUMENTS_UPLOAD_BATCH_TOTAL = (): string =>
        "{size} total";

    public static DOCUMENTS_CREATE_FOLDER_SUCCESS = (): string =>
        "Folder \"{name}\" created.";

    public static DOCUMENTS_CREATE_FOLDER_NAME_REQUIRED = (): string =>
        "Folder name is required.";

    // Locked folder badge (DEV-2572) — shown on system-managed folders (e.g. Email Attachments) to
    // every user regardless of permission level, explaining why no checkbox/actions are available.
    public static DOCUMENTS_LOCKED_FOLDER_TOOLTIP = (): string =>
        "This is a system folder and can't be renamed, moved, or deleted.";

    public static DOCUMENTS_RENAME_SUCCESS = (): string =>
        "Renamed to \"{name}\".";

    public static DOCUMENTS_RENAME_NAME_REQUIRED = (): string =>
        "Name is required.";

    public static DOCUMENTS_RENAME_EXTENSION_LOCKED = (): string =>
        "The file extension cannot be changed.";

    public static DOCUMENTS_DELETE_FILE_CONFIRMATION = (): string =>
        "Move \"{name}\" to Trash?";

    public static DOCUMENTS_DELETE_FOLDER_CONFIRMATION = (): string =>
        "Delete \"{name}\" and its {itemCount} item(s)? This cannot be undone.";

    public static DOCUMENTS_DELETE_FOLDER_SUCCESS = (): string =>
        "\"{name}\" deleted.";

    public static DOCUMENTS_PERMISSION_CHANGE_SUCCESS = (): string =>
        "Permission updated.";

    public static DOCUMENTS_PERMISSION_UPDATE_SUCCESS = (): string =>
        "Updated permission on {count} folder(s).";

    public static DOCUMENTS_MOVE_SUCCESS = (): string =>
        "\"{name}\" was moved.";

    public static DOCUMENTS_DELETE_FAILED = (): string =>
        "The items could not be deleted. Please try again.";

    // Bulk delete — folders (DEV-2481). Confirmation copy is the AC's literal wording.
    public static DOCUMENTS_BULK_DELETE_FOLDERS_TITLE = (): string =>
        "Delete {count} folder(s)?";

    public static DOCUMENTS_BULK_DELETE_FOLDERS_CONFIRMATION = (): string =>
        "Delete selected folder(s) and items contained within folder(s)? This cannot be undone. Please note that the Attachments folder and files within the Attachments folder will not be deleted.";

    public static DOCUMENTS_BULK_DELETE_FOLDERS_SUCCESS = (): string =>
        "{count} folder(s) deleted.";

    public static DOCUMENTS_BULK_DELETE_FOLDERS_PARTIAL = (): string =>
        "{count} folder(s) deleted. {skipped} skipped (locked).";

    public static DOCUMENTS_BULK_DELETE_FOLDERS_FAILED = (): string =>
        "The folders could not be deleted. Please try again.";

    // Bulk delete — files (DEV-2481).
    public static DOCUMENTS_BULK_DELETE_FILES_TITLE = (): string =>
        "Delete {count} file(s)?";

    public static DOCUMENTS_BULK_DELETE_FILES_CONFIRMATION = (): string =>
        "Delete selected file(s)? This cannot be undone.";

    public static DOCUMENTS_BULK_DELETE_FILES_SUCCESS = (): string =>
        "{count} file(s) deleted.";

    public static DOCUMENTS_BULK_DELETE_FILES_PARTIAL = (): string =>
        "{count} file(s) deleted. {skipped} could not be deleted.";

    public static DOCUMENTS_BULK_DELETE_FILES_FAILED = (): string =>
        "The files could not be deleted. Please try again.";

    public static DOCUMENTS_CREATE_FOLDER_FAILED = (): string =>
        "Could not create folder.";

    public static DOCUMENTS_RENAME_FAILED = (): string =>
        "Could not rename folder.";

    public static DOCUMENTS_RENAME_FILE_FAILED = (): string =>
        "Could not rename file.";

    public static DOCUMENTS_DELETE_FILE_SUCCESS = (): string =>
        "\"{name}\" moved to Trash.";

    // Download failures are intentionally metadata-free (no filename) — never reveal a document the
    // user can't access.
    public static DOCUMENTS_DOWNLOAD_DENIED = (): string =>
        "This document isn't available to you.";

    public static DOCUMENTS_DOWNLOAD_GONE = (): string =>
        "This document is no longer available.";

    public static DOCUMENTS_DOWNLOAD_FAILED = (): string =>
        "The file could not be downloaded. Please try again.";

    // Virus-scan status (DEV-2394). Tooltips sit on the status badge in the file grid; the messages
    // back the info modal shown if a blocked file's download is somehow still attempted.
    public static DOCUMENTS_STATUS_PENDING_TOOLTIP = (): string =>
        "Pending a virus scan — available to download once it clears.";

    public static DOCUMENTS_STATUS_QUARANTINED_TOOLTIP = (): string =>
        "Quarantined — this file can't be downloaded.";

    public static DOCUMENTS_DOWNLOAD_PENDING = (): string =>
        "This file is still being scanned and isn't available to download yet.";

    public static DOCUMENTS_DOWNLOAD_QUARANTINED = (): string =>
        "This file has been quarantined and can't be downloaded.";

    public static DOCUMENTS_MOVE_FAILED = (): string =>
        "Could not move folder.";

    public static DOCUMENTS_BULK_MOVE_SUCCESS = (): string =>
        "{count} file(s) moved.";

    // Shown when the API skipped some of the selection (e.g. files that no longer exist).
    public static DOCUMENTS_BULK_MOVE_PARTIAL = (): string =>
        "{count} file(s) moved. {skipped} could not be moved.";

    public static DOCUMENTS_BULK_MOVE_FAILED = (): string =>
        "The files could not be moved. Please try again.";

    public static DOCUMENTS_MOVE_DESTINATION_NOT_FOUND = (): string =>
        "The destination folder could not be found. It may have been moved or deleted.";

    public static DOCUMENTS_MOVE_INTO_SELF = (): string =>
        "Cannot move a folder into itself.";

    public static DOCUMENTS_MOVE_INTO_DESCENDANT = (): string =>
        "Cannot move a folder into one of its own subfolders.";

    public static DOCUMENTS_PERMISSION_UPDATE_FAILED = (): string =>
        "Update failed.";

    public static DOCUMENTS_NO_ACTIVE_ORGANIZATION = (): string =>
        "No active organization.";

    public static DOCUMENTS_FOLDER_NOT_FOUND = (): string =>
        "\"{name}\" could not be found. It may have been moved or deleted.";

    public static DOCUMENTS_CROSS_CONTAINER_CAP_EXCEEDED = (): string =>
        "This folder contains {itemCount} file(s). Moving more than {cap} file(s) between Public and private storage in one operation is not supported. Move files into smaller folders first.";

    public static DOCUMENTS_EMPTY_FOLDER_TITLE = (): string =>
        "This folder is empty.";

    public static DOCUMENTS_EMPTY_FOLDER_HELP = (): string =>
        "Drop files anywhere on the page to upload, or click Upload to choose files.";

    // Root-level empty state: files can only be uploaded inside a folder, so the copy points at
    // creating a folder rather than uploading.
    public static DOCUMENTS_EMPTY_ROOT_TITLE = (): string =>
        "No documents yet.";

    public static DOCUMENTS_EMPTY_ROOT_HELP = (): string =>
        "Create a folder to start organizing documents.";

    public static DOCUMENTS_EMPTY_SEARCH_TITLE = (): string =>
        "No documents matched your search.";

    public static DOCUMENTS_EMPTY_SEARCH_HELP = (): string =>
        "Try a different search term or clear your filters.";

    // Scope-aware label for the toolbar's filter control, so its scope is always explicit.
    public static DOCUMENTS_FILTER_FOLDER_LABEL = (): string =>
        "Filter {name}";

    public static DOCUMENTS_FILTER_ROOT_LABEL = (): string =>
        "Filter folders";

    public static DOCUMENTS_FILTER_RESULTS_LABEL = (): string =>
        "Refine results";

    // Name of the Document Center root, shown in the folder header's "Back to {parent}" / root controls.
    public static DOCUMENTS_ROOT_LABEL = (): string =>
        "Root";

    // Generic stand-in for the "Back to {parent}" control while the parent folder's name is still
    // loading (or if its fetch failed) — keeps the button accurate without naming the wrong folder.
    public static DOCUMENTS_PARENT_FALLBACK_LABEL = (): string =>
        "parent folder";

    // Search mode prompt shown before a term is typed (the API needs a term to search across folders).
    public static DOCUMENTS_SEARCH_PROMPT_TITLE = (): string =>
        "Search all documents";

    public static DOCUMENTS_SEARCH_PROMPT = (): string =>
        "Type a name to find files and folders across every folder.";

    // Generic fallback reason appended to DOCUMENTS_UPLOAD_FAILED when the API gives no specific message.
    public static DOCUMENTS_UPLOAD_GENERIC_REASON = (): string =>
        "Please try again.";

    // Info/confirmation modal titles (kept here so the title and body copy live together).
    public static DOCUMENTS_PERMISSIONS_TITLE = (): string => "Permissions";
    public static DOCUMENTS_FOLDER_MOVED_TITLE = (): string => "Folder moved";
    public static DOCUMENTS_BULK_MOVE_TITLE = (): string => "Files moved";
    public static DOCUMENTS_BULK_MOVE_FAILED_TITLE = (): string => "Move failed";
    public static DOCUMENTS_DELETE_TITLE = (): string => "Delete";
    public static DOCUMENTS_DELETED_TITLE = (): string => "Deleted";
    public static DOCUMENTS_DELETE_FAILED_TITLE = (): string => "Delete failed";
    public static DOCUMENTS_BULK_DELETE_FOLDERS_DONE_TITLE = (): string => "Folders deleted";
    public static DOCUMENTS_BULK_DELETE_FILES_DONE_TITLE = (): string => "Files deleted";
    // File delete is a soft-delete to Trash (recoverable), so files use Trash-framed copy.
    public static DOCUMENTS_MOVE_TO_TRASH_TITLE = (): string => "Move to Trash";
    public static DOCUMENTS_FILE_TRASHED_TITLE = (): string => "Moved to Trash";
    public static DOCUMENTS_DOWNLOAD_UNAVAILABLE_TITLE = (): string => "Document unavailable";
    public static DOCUMENTS_PERMISSION_UPDATED_TITLE = (): string => "Permission updated";
    public static DOCUMENTS_FOLDER_CREATED_TITLE = (): string => "Folder created";
    public static DOCUMENTS_RENAMED_TITLE = (): string => "Renamed";
    public static DOCUMENTS_UPLOAD_COMPLETE_TITLE = (): string => "Upload complete";
    public static DOCUMENTS_UPLOAD_IN_PROGRESS_TITLE = (): string => "Upload in progress";
    public static DOCUMENTS_UPLOAD_FAILED_TITLE = (): string => "Upload failed";

    // Storage usage bar graph (DEV-2426).
    public static DOCUMENTS_STORAGE_TITLE = (): string => "Storage usage";
    public static DOCUMENTS_STORAGE_USED_LABEL = (): string => "Used";
    public static DOCUMENTS_STORAGE_DELETED_LABEL = (): string => "Trash";
    public static DOCUMENTS_STORAGE_FREE_LABEL = (): string => "Free";
    public static DOCUMENTS_STORAGE_UNLIMITED = (): string => "Unlimited";

    // Bounded vs unlimited summary shown beside the title.
    public static DOCUMENTS_STORAGE_SUMMARY = (): string => "{used} of {total} used";
    public static DOCUMENTS_STORAGE_SUMMARY_UNLIMITED = (): string => "{used} used · Unlimited storage";

    // Screen-reader description of the whole bar (segments are decorative on their own).
    public static DOCUMENTS_STORAGE_ARIA = (): string =>
        "Storage usage: {used} used, {deleted} in trash, {free} free of {total} allotted.";

    public static DOCUMENTS_STORAGE_ARIA_UNLIMITED = (): string =>
        "Storage usage: {used} used, {deleted} in trash. Unlimited storage.";

    // Compact low-storage flag shown opposite the legend once free space drops to the threshold.
    public static DOCUMENTS_STORAGE_LOW_WARNING = (): string =>
        "Low storage — {free} ({percent}%) free";

    // Empty Trash — permanently (hard-)delete every soft-deleted file in the org's Trash (DEV-2427).
    // Terminology stays "Trash" to match the usage bar legend and the soft-delete flow, rather than
    // the ticket's older "Recently Deleted" wording.
    public static DOCUMENTS_EMPTY_TRASH_BUTTON = (): string => "Empty Trash";
    public static DOCUMENTS_EMPTY_TRASH_TITLE = (): string => "Empty Trash";
    public static DOCUMENTS_EMPTY_TRASH_DONE_TITLE = (): string => "Trash emptied";
    public static DOCUMENTS_EMPTY_TRASH_FAILED_TITLE = (): string => "Couldn't empty Trash";

    public static DOCUMENTS_EMPTY_TRASH_CONFIRMATION = (): string =>
        "This will permanently delete everything in the Trash. This can't be undone. Are you sure you want to continue?";

    public static DOCUMENTS_EMPTY_TRASH_SUCCESS = (): string =>
        "Permanently deleted {count} item(s) from the Trash. The reclaimed space is now free.";

    // Nothing was purged (the Trash was already empty by the time the request ran).
    public static DOCUMENTS_EMPTY_TRASH_NONE = (): string =>
        "The Trash was already empty — nothing to delete.";

    public static DOCUMENTS_EMPTY_TRASH_FAILED = (): string =>
        "The Trash could not be emptied. Please try again.";
}

export class MessageSuppressionMessagingConstants {

    public static MESSAGE_SUPPRESSION_LOAD_FAILURE = (): string =>
        "Failed to load the message suppression configuration for this organization.";

    public static MESSAGE_SUPPRESSION_SAVE_SUCCESS = (): string =>
        "Message suppression settings have been saved.";

    public static MESSAGE_SUPPRESSION_SAVE_FAILURE = (): string =>
        "Failed to save the message suppression settings.";

    public static MESSAGE_SUPPRESSION_ENABLE_CONFIRMATION_BODY = (): string =>
        "Suppression prevents this organization from sending ANY real emails, SMS, or push notifications. "
        + "Are you sure you want to enable suppression for this organization?";

    public static MESSAGE_SUPPRESSION_OVERRIDE_CONFIRMATION_BODY = (): string =>
        "All outbound emails for this organization will be redirected to {overrideEmailAddress} instead of the intended recipients. "
        + "Are you sure you want to enable the email recipient override?";
}

export class SentEmailsMessagingConstants {

    public static SENT_EMAILS_LOAD_FAILURE = (): string =>
        "Failed to load sent emails.";

    public static SENT_EMAILS_EMPTY_TITLE = (): string =>
        "No sent emails found";

    public static SENT_EMAILS_EMPTY_HELP = (): string =>
        "No emails match your search and filters. Try adjusting them.";

    public static MEMBER_COMMUNICATION_HISTORY_EMPTY_MESSAGE = (): string =>
        "No emails sent to this member yet.";
}

export class CommunicationsMessagingConstants {

    // Prefilled, editable footer shown in the Compose step so a blast never ships with an empty footer.
    public static DEFAULT_FOOTER = (): string =>
        "You are receiving this email because you are a member of {organizationName}.";

    public static SEND_CONFIRMATION = (): string =>
        "Are you sure you want to send this email to {selectedCount} recipient(s)?";

    // A single property expands to its owner + tenant(s) on send, so the count here is properties, not recipients.
    public static SEND_CONFIRMATION_PROPERTIES = (): string =>
        "Are you sure you want to send this email to {selectedCount} Property(ies)?";

    public static SEND_SUCCESS = (): string =>
        "Your email was sent to {totalAffected} recipient(s). {totalSkipped} skipped of {totalEvaluated} evaluated.";

    public static SEND_FAILURE = (): string =>
        "Failed to send the email. Please try again.";

    public static NO_RECIPIENTS_HELP = (): string =>
        "Select at least one recipient to continue.";

    // The recipient list hides members with no email address so an email can actually reach them;
    // this is why a filter that would normally match may come back empty.
    public static RECIPIENT_LIST_EMPTY = (): string =>
        "No members with an email address match this filter.";

    public static RECIPIENT_LIST_LOAD_FAILED = (): string =>
        "We couldn't load recipients. Please try again.";

    // Attachments — shown in and around the composer's attachment picker.
    public static ATTACHMENTS_STORAGE_NOTE = (): string =>
        "Uploaded files are saved to your organization's Document Center and count toward its storage.";

    public static ATTACHMENT_TOTAL_LIMIT_EXCEEDED = (): string =>
        "\"{name}\" wasn't attached — it would exceed the {limit} total attachment limit.";

    public static ATTACHMENT_ALREADY_ATTACHED = (): string =>
        "\"{name}\" is already attached.";

    public static ATTACHMENT_QUARANTINED_REMOVED = (): string =>
        "\"{name}\" was flagged by the virus scan and removed — it hasn't been attached.";

    public static ATTACHMENTS_FOLDER_RESOLVE_FAILED = (): string =>
        "Couldn't prepare the attachments folder. Please try again.";

    // Shown on the send-confirmation when the blast carries attachments (queue-until-scanned behavior).
    public static ATTACHMENTS_SEND_QUEUE_NOTICE = (): string =>
        "This message will be queued while its attachment(s) are scanned for viruses, then sent once they pass. "
        + "Track its status in the sent-email history.";
}

export class SupportMessagingConstants {

    public static PAGE_INTRO = (): string =>
        "Need help? Send a message to the HOA Start Support team and we'll get back to you shortly.";

    public static SUBMIT_SUCCESS = (): string =>
        "Thank you for submitting a support request. Our Support team has received it and will email you shortly.";

    public static SUBMIT_FAILURE = (): string =>
        "We couldn't submit your support request. Please try again.";
}

export class DashboardMessagingConstants {

    public static DASHBOARD_NO_ACTIVE_ORGANIZATION = (): string =>
        "You are not a Member of an active Organization.";
}
export class FeatureFlagsMessagingConstants {

    public static FLAGS_SEARCH_PLACEHOLDER = (): string =>
        "Search Feature Flags";

    public static FLAGS_SEARCH_DESCRIPTION = (): string =>
        "Search by key or description";

    public static FLAGS_EMPTY = (): string =>
        "No feature flags are defined.";

    public static FLAGS_EMPTY_FOR_SEARCH = (): string =>
        "No feature flags match your search.";

    public static DEFAULT_CHANGE_CONFIRMATION = (): string =>
        "Turn the default for {flagKey} {stateText}? This applies to {affectedCount} organization(s) with no override for this flag.";

    public static DEFAULT_CHANGE_OVERRIDES_NOTE = (): string =>
        "{overrideCount} organization(s) override this flag and keep their current value.";

    // Shown instead of the affected count when the organization total could not be read, so the
    // confirmation never states a number it did not get from the API.
    public static DEFAULT_CHANGE_CONFIRMATION_COUNT_UNAVAILABLE = (): string =>
        "Turn the default for {flagKey} {stateText}? This applies to every organization with no override for this flag.";

    public static DEFAULT_CHANGE_SUCCESS = (): string =>
        "The default for {flagKey} is now {stateText}.";

    public static DEFAULT_CHANGE_FAILURE = (): string =>
        "We couldn't change the default for {flagKey}. Please try again.";

    public static OVERRIDES_EMPTY = (): string =>
        "No organization overrides are in place.";

    public static OVERRIDES_EMPTY_FOR_FILTER = (): string =>
        "No overrides match the selected filters.";

    public static OVERRIDE_ADD_TITLE = (): string =>
        "Add Override";

    public static OVERRIDE_EDIT_TITLE = (): string =>
        "Edit Override";

    public static OVERRIDE_CREATE_SUCCESS = (): string =>
        "{organizationName} now overrides {flagKey} to {stateText}.";

    public static OVERRIDE_UPDATE_SUCCESS = (): string =>
        "{organizationName}'s override for {flagKey} is now {stateText}.";

    public static OVERRIDE_SAVE_FAILURE = (): string =>
        "We couldn't save the override. Please try again.";

    // Wording fixed by the ticket's Gherkin — the duplicate scenario asserts this exact sentence.
    public static OVERRIDE_DUPLICATE = (): string =>
        "This organization already has an override for this flag";

    public static OVERRIDE_GLOBAL_ONLY = (): string =>
        "This flag is global-only and cannot be overridden for a single organization.";

    public static OVERRIDE_REMOVE_CONFIRMATION = (): string =>
        "Remove {organizationName}'s override for {flagKey}? The organization will follow the flag's default of {defaultStateText}.";

    // Used when the flag's default could not be read. Naming a value here would mean naming the
    // override's own, which is the one value the default is guaranteed not to be.
    public static OVERRIDE_REMOVE_CONFIRMATION_UNKNOWN_DEFAULT = (): string =>
        "Remove {organizationName}'s override for {flagKey}? The organization will follow the flag's default.";

    public static OVERRIDE_REMOVE_SUCCESS = (): string =>
        "The override was removed. {organizationName} now follows the default for {flagKey}.";

    public static OVERRIDE_REMOVE_FAILURE = (): string =>
        "We couldn't remove the override. Please try again.";

    public static OVERRIDE_VALUE_HELP = (): string =>
        "This organization uses the value above instead of the flag's default.";

    public static OVERRIDE_NOTE_HELP = (): string =>
        "Optional. Recorded against this change in the flag's history.";

    public static ORGANIZATION_REQUIRED = (): string =>
        "Select an organization.";

    public static FLAG_REQUIRED = (): string =>
        "Select a feature flag.";

    public static STATE_ON = (): string => "On";

    public static STATE_OFF = (): string => "Off";

    // The confirmation's action button: a bare "On" reads as a label for the current state rather
    // than as the thing the button is about to do.
    public static TURN_ON = (): string => "Turn On";

    public static TURN_OFF = (): string => "Turn Off";
}

export class AddressVerificationMessagingConstants {

    public static TITLE_CORRECTION = (): string => "Check this address";

    public static TITLE_ISSUES = (): string => "This address may not be deliverable";

    public static TITLE_UNDELIVERABLE = (): string => "We couldn't confirm this address";

    public static PROMPT_CORRECTION = (): string =>
        "We found a different version of the address you entered. Choose the one you want to save, or go back and edit what you entered.";

    public static PROMPT_NO_DIFFERENCE = (): string =>
        "We confirmed the address you entered. Save it as it is, or go back and edit what you entered.";

    public static PROMPT_ZIP_EXTENSION = (): string =>
        "We added the full ZIP+4 code for the address you entered. Choose the one you want to save.";

    public static PROMPT_ISSUES = (): string =>
        "The mail service reported a problem with the information supplied.";

    public static PROMPT_UNDELIVERABLE = (): string =>
        "The mail service could not confirm that this address receives mail.";

    public static LABEL_ORIGINAL = (): string => "You entered";

    public static LABEL_STANDARDIZED = (): string => "We suggest";

    public static BUTTON_CONFIRM = (): string => "Confirm";

    public static BUTTON_EDIT = (): string => "Edit Address";

    public static UNVERIFIED_SELECTION_WARNING = (): string =>
        "Selecting the address you entered rather than our standardized version may result in undelivered mail.";

    // 503 and 403 both land here: an outage, a missing provider key, rate limiting, or the feature
    // turned off for this organization. None of them is something the user can act on differently.
    public static UNAVAILABLE_CONFIRMATION = (): string =>
        "Address validation is temporarily unavailable. Would you like to save this address without verifying it?";

    public static REJECTED_TITLE = (): string => "We couldn't check this address";
}


export class StaffManagementMessagingConstants {

    public static STAFF_ADD_ROLE_SUCCESS = (): string =>
        "Role has been added successfully.";

    public static STAFF_ROLE_REMOVAL_SUCCESS = (): string =>
        "Role has been removed successfully.";

    public static STAFF_ASSIGN_ROLE_CONFIRMATION = (): string =>
        "Are you sure you want to assign {roleName} privileges to {firstName} {lastName}?</br></br>Staff roles carry platform-wide privileges across every organization. Only grant staff access to trusted Users.";

    public static STAFF_UNASSIGN_ROLE_CONFIRMATION = (): string =>
        "Are you sure you want to remove {roleName} privileges from {firstName} {lastName}?";

    public static STAFF_ERROR_ASSIGNING_ROLE = (): string =>
        "An unexpected error occurred while assigning {roleName} privileges.";

    public static STAFF_ERROR_UNASSIGNING_ROLE = (): string =>
        "An unexpected error occurred while removing {roleName} privileges.";

    public static STAFF_CHOOSE_ROLE_PROMPT = (): string =>
        "Which role should they be given?";

    public static STAFF_ALL_ROLES_HELD = (): string =>
        "{firstName} already holds every role you are able to grant.";

    public static STAFF_ROLE_REMOVE_NOT_PERMITTED = (): string =>
        "You do not have permission to remove this role.";

    public static STAFF_REMOVE_BLOCKED_SELF = (): string =>
        "You cannot remove your own staff roles. Ask another administrator to make this change.";

    public static STAFF_REMOVE_BLOCKED_AUTHORITY = (): string =>
        "These roles carry the same or greater authority than your own, so they cannot be removed here.";

    public static STAFF_REMOVE_BLOCKED_PERMISSION = (): string =>
        "You do not have permission to remove this User's roles.";

    public static STAFF_ROLES_NOT_FOUND = (): string =>
        "These roles could not be found: {roleNames}.";

    public static STAFF_ERROR_LOADING_ROLES = (): string =>
        "An unexpected error occurred while loading roles.";

    public static STAFF_ERROR_LOADING_STAFF = (): string =>
        "Failed to load Staff Managers and Staff.";

    public static STAFF_ERROR_LOADING_USERS = (): string =>
        "Failed to load Users.";

    public static STAFF_ERROR_LOADING_ASSIGNMENTS = (): string =>
        "Failed to load current staff role assignments.";
}

export class ImportMessagingConstants {

    public static IMPORT_START_IMPORT_UNAVAILABLE_TOOLTIP = (): string =>
        "Importing is not available yet. It will be ready in an upcoming release.";

    public static IMPORT_TEMPLATE_DOWNLOAD_FAILED_TITLE = (): string => "Template unavailable";

    public static IMPORT_TEMPLATE_DOWNLOAD_DENIED = (): string =>
        "You don't have permission to download the import template.";

    public static IMPORT_TEMPLATE_DOWNLOAD_FAILED = (): string =>
        "The import template could not be downloaded. Please try again.";

    //#region Upload

    public static IMPORT_UPLOAD_NOT_CSV = (): string => "Choose a .csv file. Save your spreadsheet as CSV and try again.";

    public static IMPORT_UPLOAD_EMPTY_FILE = (): string => "That file is empty.";

    public static IMPORT_UPLOAD_TOO_LARGE = (): string => "That file is larger than the {limit} limit.";

    // The API names this one too, but its message carries the organization's internal ID, so the
    // page says it in its own words instead. (DEV-2718)
    public static IMPORT_UPLOAD_ALREADY_IN_PROGRESS = (): string =>
        "This organization already has an import in progress. Resume it, or cancel it before uploading another file.";

    public static IMPORT_UPLOAD_DENIED = (): string => "You don't have permission to import into this organization.";

    public static IMPORT_UPLOAD_FAILED = (): string => "The file could not be uploaded. Please try again.";

    //#endregion Upload

    //#region Resume

    public static IMPORT_IN_PROGRESS_TITLE = (): string => "You have an import in progress";

    public static IMPORT_IN_PROGRESS_MESSAGE = (): string => "{fileName} — {rowCount} rows staged. Resume where you left off, or cancel it to start over.";

    public static IMPORT_RESUME_LOOKUP_FAILED = (): string => "We could not check whether this organization already has an import in progress. Starting a new one now would be refused if it does, so try again before uploading a file.";

    // Both answers to "Discard staged rows" say what happens to the uploaded file as well as the rows,
    // because discarding takes the whole import and not only the corrections made to it.
    public static IMPORT_DISCARD_KEEP_TOOLTIP = (): string => "Keep uploaded file and staged rows";

    public static IMPORT_DISCARD_CONFIRM_TOOLTIP = (): string => "Discard uploaded file and staged rows";

    //#endregion Resume

    //#region Wizard

    public static IMPORT_CANCEL_CONFIRMATION = (): string =>
        "Cancelling discards every staged row, including the corrections you have made. You would need to upload the file again. Cancel this import?";

    public static IMPORT_CANCEL_FAILED = (): string => "The import could not be cancelled. Please try again.";

    public static IMPORT_DELETE_ROW_CONFIRMATION = (): string => "Delete row {rowNumber}? It can only be recovered by uploading the file again.";

    public static IMPORT_ROWS_LOAD_FAILED = (): string => "The staged rows could not be loaded. Please try again.";

    public static IMPORT_ROW_SAVE_FAILED = (): string => "The row could not be saved. Please try again.";

    public static IMPORT_ROW_DELETE_FAILED = (): string => "The row could not be deleted. Please try again.";

    public static IMPORT_ROW_LIMIT_REACHED = (): string => "This import already holds the maximum of {limit} rows, so no more can be added.";

    public static IMPORT_REPLACE_FILE_CONFIRMATION = (): string =>
        "Choosing a different file discards the rows staged from this one, including any corrections. Continue?";

    public static IMPORT_NEXT_BLOCKED_BY_ERRORS = (): string => "Correct or delete the {errorCount} flagged cells before continuing.";

    public static IMPORT_NEXT_STEP_UNAVAILABLE = (): string => "The next step is not available yet. It will be ready in an upcoming release.";

    public static IMPORT_NO_FLAGGED_ROWS = (): string => "No rows are flagged. Clear the filter to see every staged row.";

    //#endregion Wizard

    //#region Dedupe

    // The dedupe routes refuse an import that still has a flagged cell, and this step has no way to
    // correct one, so the message sends the reader back rather than offering a retry. (DEV-2719)
    public static IMPORT_DUPLICATES_BLOCKED_BY_ERRORS = (): string => "Every row has to be free of errors before duplicates can be reviewed. Go back to the validation preview to correct or delete the rows that are still flagged.";

    public static IMPORT_DUPLICATES_DENIED = (): string => "You don't have permission to import into this organization.";

    public static IMPORT_DUPLICATES_LOAD_FAILED = (): string => "The possible duplicates could not be loaded. Please try again.";

    public static IMPORT_DUPLICATE_ROWS_LOAD_FAILED = (): string => "The rows with possible duplicates could not be loaded. Please try again.";

    public static IMPORT_DECISION_FAILED = (): string => "That decision could not be saved. Please try again.";

    // Said after a decision the API copied to the other rows describing the same record. It can only
    // ever give a count: the response reports how many rows are left, never which ones moved.
    public static IMPORT_DECISION_APPLIED_TO_GROUP = (): string => "That decision was applied to {count} other row(s) describing the same record.";

    // Shown in place of the card once a decision takes its row out of the filtered list. Without it the
    // row vanishes under the click that settled it, with nothing to confirm the click landed and no
    // sign that the decision can still be changed — which the API allows for as long as the import is
    // staged.
    public static IMPORT_DECISION_RECORDED = (): string => "Row {row} — {decision}. Turn the filter off to see it again or change it.";

    public static IMPORT_DECISION_STALE_RELOADED = (): string => "The list has been refreshed, because the records this row may duplicate have changed.";

    // Why Create new is offered but unavailable. The API sends a bare flag with no reason attached, so
    // this states the rule rather than the particular cause.
    public static IMPORT_CREATE_NEW_BLOCKED_MEMBER = (): string => "This row matches a member who already exists in this organization, so it cannot be imported as a new one. Keep that member, or overwrite them.";

    // Said once above the property list rather than on every card. A property is matched on its address
    // or its lot number and never on its title, and both identify a property the organization already
    // has, so Create new is refused for every property row there can be.
    public static IMPORT_DUPLICATES_PROPERTY_CREATE_NEW_RULE = (): string => "A property is matched on its address or lot number, both of which identify a property this organization already has — so these rows can only be kept or overwritten, never imported as new properties.";

    public static IMPORT_DUPLICATES_MEMBER_COUNT = (): string => "{total} row(s) look like a member this organization already has. {unresolved} still need a decision.";

    public static IMPORT_DUPLICATES_PROPERTY_COUNT = (): string => "{total} row(s) look like a property this organization already has. {unresolved} still need a decision.";

    public static IMPORT_DUPLICATES_NO_MEMBERS = (): string => "No rows look like a member this organization already has.";

    public static IMPORT_DUPLICATES_NO_PROPERTIES = (): string => "No rows look like a property this organization already has.";

    // Shown in place of the list once the filter has nothing left to offer, rather than an empty box.
    public static IMPORT_DUPLICATES_ALL_RESOLVED = (): string => "All {total} row(s) have a decision. Turn the filter off to review them.";

    public static IMPORT_NEXT_BLOCKED_BY_DUPLICATES = (): string => "Decide what to do with the {count} row(s) that may duplicate a record this organization already has.";

    //#endregion Dedupe
}
